<app-page-header
  title="Meine Coin-Transaktionen"
  subtitle="Alle deine Coin-Transaktionen im Überblick"
  icon="account_balance_wallet"
  variant="gradient">
</app-page-header>

<div class="apple-container">
    <div class="apple-transaction-history-table-card apple-card">
        <table class="apple-transaction-history-table">
            <thead>
                <tr class="apple-table-header-row">
                    <th class="global-table-header-cell">Datum</th>
                    <th class="global-table-header-cell">Grund</th>
                    <th class="global-table-header-cell">Auftragsnummer</th>
                    <th class="global-table-header-cell">Betrag</th>
                    <th class="global-table-header-cell">Vergeben von</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let tx of transactions$ | async" class="apple-table-row">
                    <td class="global-table-cell">{{ tx.createdDate | date:'dd.MM.yyyy' }}</td>
                    <td class="global-table-cell">{{ tx.reason?.reasonText }}</td>
                    <td class="global-table-cell">{{ tx.reflexOrderNo || '-' }}</td>
                    <td class="global-table-cell">
                        <span [class.positive-amount]="(tx.amount || 0) > 0" 
                              [class.negative-amount]="(tx.amount || 0) < 0">
                            {{ tx.amount }}
                        </span>
                    </td>
                    <td class="global-table-cell">
                        {{ tx.reason?.reasonText?.includes('Generiert') ? 'Niclen GmbH' : (tx.grantedBy ? (tx.grantedBy.firstName + ' ' + tx.grantedBy.lastName) : '-') }}
                    </td>
                </tr>
            </tbody>
        </table>
        <div *ngIf="(transactions$ | async)?.length === 0" class="empty-state">
            <mat-icon>info</mat-icon>
            <p>Noch keine Transaktionen vorhanden.</p>
        </div>
    </div>
</div>

<div class="apple-container action-buttons">
    <button class="apple-button apple-button-secondary" (click)="exportToCSV()">
        <mat-icon class="order-back-icon">download</mat-icon>
        Exportieren als CSV
    </button>
    <button class="apple-button apple-button-primary" (click)="back()">
        <mat-icon class="order-back-icon">arrow_back</mat-icon>
        Zurück
    </button>
</div>
